export default 'https://tme.understood.org/assets/outro.en.7374b55e.vtt'